import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
import { Experiment } from '@amplitude/experiment-js-client';
import { AmplitudeExperimentContext } from "./AmplitudeExperimentContext";
import { jsx as _jsx } from "react/jsx-runtime";
var AmplitudeExperimentProvider = function AmplitudeExperimentProvider(_ref) {
  var envExperimentKey = _ref.envExperimentKey,
    _ref$debugMode = _ref.debugMode,
    debug = _ref$debugMode === void 0 ? false : _ref$debugMode,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var startExperiment = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(experiment) {
      var experimentClient;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return experiment.fetch();
          case 4:
            experimentClient = _context.sent;
            setLoaded(true);
            setLoading(false);
            return _context.abrupt("return", experimentClient);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
            setLoaded(false);
          case 14:
            setLoading(false);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 10]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var getExperiment = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var internExperiment, experimentClient;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(typeof window === 'undefined' || !envExperimentKey)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", Promise.reject(new Error('envExperimentKey is required')));
        case 2:
          internExperiment = Experiment.initializeWithAmplitudeAnalytics(envExperimentKey, {
            debug: debug
          });
          _context2.next = 5;
          return startExperiment(internExperiment);
        case 5:
          experimentClient = _context2.sent;
          if (experimentClient) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return", Promise.reject(new Error('ExperimentClient is undefined')));
        case 8:
          if (debug) {}
          return _context2.abrupt("return", experimentClient);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [envExperimentKey, debug, startExperiment]);
  var isVariantActive = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(variantId, variantValue) {
      var experiment, variantObject;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getExperiment();
          case 2:
            experiment = _context3.sent;
            if (!(typeof experiment !== 'undefined')) {
              _context3.next = 8;
              break;
            }
            variantObject = experiment.variant(variantId);
            if (!variantValue) {
              _context3.next = 7;
              break;
            }
            return _context3.abrupt("return", variantObject.value === variantValue);
          case 7:
            return _context3.abrupt("return", variantObject.value !== 'control');
          case 8:
            return _context3.abrupt("return", false);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function isVariantActive(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var isControlActive = function isControlActive(variantId) {
    var defaultControl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'control';
    return isVariantActive(variantId, defaultControl);
  };
  function getPayloadVariant(_x4) {
    return _getPayloadVariant.apply(this, arguments);
  }
  function _getPayloadVariant() {
    _getPayloadVariant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(variantId) {
      var experiment, variantObject;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getExperiment();
          case 2:
            experiment = _context4.sent;
            if (!experiment) {
              _context4.next = 6;
              break;
            }
            variantObject = experiment.variant(variantId);
            return _context4.abrupt("return", variantObject.payload);
          case 6:
            return _context4.abrupt("return", null);
          case 7:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _getPayloadVariant.apply(this, arguments);
  }
  var value = {
    getExperiment: getExperiment,
    loading: loading,
    loaded: loaded,
    isVariantActive: isVariantActive,
    isControlActive: isControlActive,
    getPayloadVariant: getPayloadVariant
  };
  return /*#__PURE__*/_jsx(AmplitudeExperimentContext.Provider, {
    value: value,
    children: children
  });
};
export { AmplitudeExperimentContext, AmplitudeExperimentProvider };